export const NOT_EXPORT_ORDER_TABLE_TYPE = 'notExportedOrderTable';
